export enum FlightStatus {
    // TODO: remove new record flight status, it doesn't make sense, flight without position is valid
    NewRecord = -1, // Newly added record, neither position nor flight parameters have been set
    NotValid = 0, // Not a valid plane record
    Departed = 1, // Plane departed but no position reported
    Active = 2, // One or more position reports received
    Arrived = 3, // Arrival message received
    Agedout = 4, // No message received for 8 minutes
    Hold = 5,
    Planned = 6,
    Scheduled = 7,
    Parked = 8
}

export enum TimeDistanceMode {
    nextLast = 0,
    all = 1
}

export enum TagBorderMode {
    none = 0,
    likeText = 1,
    other = 2
}

export enum FuelUnit {
    Null = 0,
    WeighPounds = 1,
    VolumeGallons = 2,
    WeightKilograms = 3,
    VolumeLiters = 4
}
